import { faComment } from "@fortawesome/free-solid-svg-icons";
import i18n from "../../../../../../constants/i18n";
import getUserAdvancedStore from "../../../../../../stores/user-store/advanced-store";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../../../core/et3-input/et3-text-input";
import Et3Button from "../../../../../../core/et3-button";
import { isDefinedString } from "et3-type-guards";

const UserChangeUserName = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const userID = getUserAdvancedStore().currentUserId.get();
  const userStatusDeleted = getUserAdvancedStore().userStatusDeleted.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={300}
      height={260}
      fDirection="column"
      alignItems="center"
      justifyContent="space-between"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        type={"text"}
        icon={faComment}
        label={""}
        placeHolder={i18n.get("USERNAME")}
        value={getUserAdvancedStore().changeUsernameInput.get()}
        onChoose={(value: string) =>
          getUserAdvancedStore().changeUsernameInput.set(value)
        }
        onBlur={() => {}}
        style={{}}
        onEnter={() => {}}
      />
      <Et3Button
        isEnabled={
          !userStatusDeleted &&
          isDefinedString(getUserAdvancedStore().changeUsernameInput.get())
        }
        onClick={async () =>
          await getUserAdvancedStore().changeUsername(userID)
        }
        type="GET"
        size="MEDIUM"
        text="CHANGE_USERNAME"
      />
    </ET3Div>
  );
});
export default UserChangeUserName;
